import { IMenuItem, mainMenu } from '@app/components/Sidebar/menuObject';
import { TranslationsTypes } from '@app/models';

export function getMenuItemById(id: number | null, menuItems?: IMenuItem[]): IMenuItem | undefined {
    const menu: IMenuItem[] = menuItems ? menuItems : mainMenu;
    let result: IMenuItem | undefined = undefined;

    if (id !== null) {
        for (let obj of menu) {
            result = dfsForId(obj, id);
            if (result) {
                return result;
            }
        }
    }
}

export function getMenuItemByLinkChunk(chunk: string, menuItems?: (IMenuItem | undefined)[]): IMenuItem | undefined {
    const menu: (IMenuItem | undefined)[] = menuItems ? menuItems : mainMenu;
    let result: IMenuItem | undefined = undefined;

    for (let obj of menu) {
        result = dfsForLink(obj, chunk);
        if (result) {
            return result;
        }
    }
}

function dfsForId(obj: IMenuItem, targetId: number): IMenuItem | undefined {
    if (obj.id === targetId) {
        return obj;
    }
    if (obj.children) {
        for (let item of obj.children) {
            let check = dfsForId(item, targetId);
            if (check) {
                return check;
            }
        }
    }
}

function dfsForLink(obj: IMenuItem | undefined, targetLink: string): IMenuItem | undefined {
    if (obj !== undefined && obj.linkChunk === targetLink) {
        return obj;
    }
    if (obj !== undefined && obj.children) {
        for (let item of obj.children) {
            let check = dfsForLink(item, targetLink);
            if (check) {
                return check;
            }
        }
    }
}

export function getMenuItemNameById(id: number, menuItems?: IMenuItem[]): string {
    const menuItemObject: IMenuItem | undefined = getMenuItemById(id, menuItems);
    return menuItemObject ? menuItemObject.name : '';
}

export function getMenuItemIconById(id: number, menuItems?: IMenuItem[]): string {
    const menuItemObject: IMenuItem | undefined = getMenuItemById(id, menuItems);
    return menuItemObject?.icon ? menuItemObject.icon : '';
}

export function getMenuItemLinkById(id: number, menuItems?: IMenuItem[]): string | undefined {
    const menuItemObject: IMenuItem | undefined = getMenuItemById(id, menuItems);
    return menuItemObject ? menuItemObject.link : '';
}

export function getMenuItemNameByChunk(chunk: string, menuItems?: (IMenuItem | undefined)[]): TranslationsTypes {
    const menuItemObject: IMenuItem | undefined = getMenuItemByLinkChunk(chunk, menuItems);
    return menuItemObject ? menuItemObject.name : '';
}

export function getMenuItemIdByChunk(chunk: string, menuItems?: IMenuItem[]): number | null {
    const menuItemObject: IMenuItem | undefined = getMenuItemByLinkChunk(chunk, menuItems);
    return menuItemObject ? menuItemObject.id : null;
}

export function getMenuItemLinkByChunk(chunk: string, menuItems?: (IMenuItem | undefined)[]): string | undefined {
    const menuItemObject: IMenuItem | undefined = getMenuItemByLinkChunk(chunk, menuItems);
    return menuItemObject ? menuItemObject.link : '';
}
